var UgcCarousel = function () {
  if ("loading" in HTMLImageElement.prototype) {
    const lazyVideos = document.querySelectorAll('video[loading="lazy"]');
    lazyVideos.forEach((video) => {
      video.src = video.dataset.src;
    });
  }
  const profPhotos = document.querySelector("#prof-photos");
  const socialProduct = document.querySelector("#social-product");
  const photogVideo = document.querySelector("#photog-video");

  if (profPhotos && socialProduct && photogVideo) {
    var mvnsplide1 = new Splide("#prof-photos", {
      type: "slide",
      perPage: 4,
      pagination: false,
      arrows: false,
      padding: "15px",
      gap: "20px",
      isNavigation: true,
      breakpoints: {
        640: {
          gap: "10px",
        },
      },
    }).mount();

    var mvnsplide2 = new Splide("#social-product", {
      type: "fade",
      perPage: 1,
      perMove: 1,
      pagination: false,
      gap: "20px",
      arrows: false,
      focus: "center",
      trimSpace: false,
    }).mount();

    var mvnsplide3 = new Splide("#photog-video", {
      type: "slide",
      perPage: 1,
      perMove: 1,
      pagination: false,
      gap: "20px",
      focus: "center",
      trimSpace: false,
    }).mount();

    mvnsplide1.sync(mvnsplide2);
    mvnsplide1.sync(mvnsplide3);
  }
  /*
  mvnsplide1.mount();
  mvnsplide2.mount();
  mvnsplide3.mount();
  */
};
var OurTeamSlider = function () {
  const aboutTeam = document.querySelector(".about-team__carousel");
  if (aboutTeam) {
    $(".about-team__carousel").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      prevArrow:
        "<button type='button' class='slick-prev pull-left'>&nbsp;</button>",
      nextArrow:
        "<button type='button' class='slick-next pull-right'>&nbsp;</button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
};
var SrollGridView = function() {
$(".cb-value").click(function () {
  $(this).toggleClass("favourite");
  var mainParent = $(this).parent(".toggle-btn");
  if ($(mainParent).find("input.cb-value").is(":checked")) {
    $(mainParent).addClass("active");
    $(
      ".product-swatch-duoboards.product-swatch-duoboards-style.mobile-mode-only"
    ).addClass("grid-view-enable");
    localStorage.setItem("favourited", "yes");
  } else {
    localStorage.setItem("favourited", "no");
    $(mainParent).removeClass("active");
    $(
      ".product-swatch-duoboards.product-swatch-duoboards-style.mobile-mode-only"
    ).removeClass("grid-view-enable");
  }
  if (localStorage.getItem("favourited") == "yes") {
    $(".toggle-btn").addClass("active");
    $(
      ".product-swatch-duoboards.product-swatch-duoboards-style.mobile-mode-only"
    ).addClass("grid-view-enable");
  } else {
    $(".toggle-btn").removeClass("active");
    $(
      ".product-swatch-duoboards.product-swatch-duoboards-style.mobile-mode-only"
    ).removeClass("grid-view-enable");
  }
});

if (localStorage.getItem("favourited") == "yes") {
  $(".toggle-btn").addClass("active");
  $(
    ".product-swatch-duoboards.product-swatch-duoboards-style.mobile-mode-only"
  ).addClass("grid-view-enable");
} else {
  $(".toggle-btn").removeClass("active");
  $(
    ".product-swatch-duoboards.product-swatch-duoboards-style.mobile-mode-only"
  ).removeClass("grid-view-enable");
}
};
var CarouselImagesSlider = function() {
$('.carousel-images').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  prevArrow:
        "<button type='button' class='prev-arrow slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0016/9243/4534/files/arrow-left_60825d3c-de03-4e01-ab06-8cd511525a20.svg?v=1708680339'></button>",
  nextArrow:
        "<button type='button' class='next-arrow slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0016/9243/4534/files/arrow-right_871c6479-4164-446e-8541-b7776f8fb917.svg?v=1708680339'></button>"
});
};

CarouselImagesSlider();
SrollGridView();
OurTeamSlider();
UgcCarousel();
$(document).on("shopify:section:load", function (event) {
  CarouselImagesSlider();
  SrollGridView();
  OurTeamSlider();
  UgcCarousel();
  
});



 // Bundle Swatch script
  let topAvailable = true;
  let bottomAvailable = true;

  $("[js-bundle-swatch-top]").on("click", function () {
    bundleAvailable($(this), "top", function(available) {
      topAvailable = available;
      updateBundleATC(topAvailable, bottomAvailable);
    });
  });
  
  $("[js-bundle-swatch-bottom]").on("click", function () {
    bundleAvailable($(this), "bottom", function(isAvailable) {
      bottomAvailable = isAvailable;
      updateBundleATC(topAvailable, bottomAvailable);
    });
  });

  $(".build-bundle__input").on("click", function () {
    let topBundle = $(".build-bundle__swatch.top.active").children().first();
    let bottomBundle = $(".build-bundle__swatch.bottom.active").children().first();

    bundleAvailable(topBundle, "top", function(isAvailable) {
      topAvailable = isAvailable;
      updateBundleATC(topAvailable, bottomAvailable);
    });
    
    bundleAvailable(bottomBundle, "bottom", function(isAvailable) {
      bottomAvailable = isAvailable;
      updateBundleATC(topAvailable, bottomAvailable);
    });
  });

  function updateBundleATC(topAvailable, bottomAvailable) {
    if(topAvailable && bottomAvailable){
      $("[js-bundle-add]").text('Add to Cart');
      $("[js-bundle-add]").prop('disabled', false);
    } else {
      $("[js-bundle-add]").text('Out of Stock');
      $("[js-bundle-add]").prop('disabled', true);
    }
  }

  function bundleAvailable($this, side, callback) {
    let isAvailable;
    var handle = '';
    $(".build-bundle__input").each(function () {
      if (this.checked) {
        if (this.value == 'small') {
          handle = $this.data("small-handle");
        } else {
          handle = $this.data("large-handle");
        }
      }
    });

    jQuery.getJSON(window.Shopify.routes.root + 'products/' + handle + '.js', function(product) {
      if (product.available) {
        isAvailable = true;
        bundleSwatch($this, side);
      } else {
        isAvailable = false;
        bundleSwatch($this, side);
      }
      callback(isAvailable);
    });
  }
  
  function bundleSwatch($this, side) {
    var id = $this.data("id");
    var color1 = $this.data("color1");
    var color2 = $this.data("color2");

    if (side == 'top')
      $(".top .title-colors").html(color1 + '/' + color2)
    else if (side == 'bottom')
      $(".bottom .title-colors").html(color1 + '/' + color2)

    var $activeImages = $(
      "[js-bundle-" + side + '-images][data-id="' + id + '"]'
    );
    var $parent = $this.parent();
    $parent.addClass("active");
    $(".build-bundle__swatch." + side)
      .not($parent)
      .removeClass("active");
  
    $activeImages.addClass("active");
    $("[js-bundle-" + side + "-images]")
      .not($activeImages)
      .removeClass("active");
  }
  
  $("[js-bundle-flip-top]").on("click", function () {
    var $images = $("[js-bundle-images].active");
    var $currentActiveTop = $images.find("[js-bundle-top].show");
    $currentActiveTop
      .removeClass("show")
      .siblings("[js-bundle-top]")
      .addClass("show");
  });
  
  $("[js-bundle-flip-bottom]").on("click", function () {
    var $images = $("[js-bundle-images].active");
    var $currentActiveBottom = $images.find("[js-bundle-bottom].show");
    $currentActiveBottom
      .removeClass("show")
      .siblings("[js-bundle-bottom]")
      .addClass("show");
  });
  
  $("[js-bundle-add]").on("click", function () {
    Shopify.queue = [];
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    var size = '';
    $(".build-bundle__input").each(function () {
      if(this.checked){
        if(this.value == 'small'){
          size = 'small'
        }else {
          size = 'large';
        }
      }
    });

    if (size == 'small'){
      $(".build-bundle__swatch.active").each(function () {
        Shopify.queue.push({
          id: $(this).find("[js-bundle-swatch]").data("small"),
          quantity: 1,
          sections: sectionsToBundle.join(",")
        });
      });
    } else {
      $(".build-bundle__swatch.active").each(function () {
        Shopify.queue.push({
          id: $(this).find("[js-bundle-swatch]").data("large"),
          quantity: 1,
          sections: sectionsToBundle.join(",")
        });
      });
    }
  
    Shopify.moveAlong = async function () {
      if (Shopify.queue.length) {
        var queue = Shopify.queue.shift();
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          dataType: "json",
          data: queue,
          success: function (data) {
            document.documentElement.dispatchEvent(new CustomEvent("variant:add", {
              bubbles: true,
              detail: {
                items: data,
                cart: data
              }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: data
              }
            }));

            Shopify.moveAlong();
          },
          error: function (err) {
            if (Shopify.queue.length) {
              Shopify.moveAlong();
            } else {
              ajaxCart.load();
            }
          },
        });
      }
    };
  
    Shopify.moveAlong();
  });

// collapsable footer block
  $(".v-stack.gap-4.collapsable p.h6").click(function (e) {
    if ($(window).width() < 768) {
      e.preventDefault();
      $(this).siblings(".prose").slideToggle();
      $(this).toggleClass("open");
    }
  });
  // lightbox
  $(function () {
    function showModal(index) {
      $(".lightbox-images").hide();
      $(".lightbox-modal").show();
      $(".lightbox-modal-slide").hide();
      $(".lightbox-modal-slide").each(function (i, el) {
        if ($(el).data("slide") == index) {
          $(el).show();
        }
      });
    }
    function closeModal() {
      $(".lightbox-modal").hide();
      $(".lightbox-images").show();
    }
  
    $(".lightbox-images-image").click(function (e) {
      e.preventDefault();
      var index = $(this).data("slide");
      showModal(index);
    });
    $(".lightbox-modal .prev").click(function (e) {
      e.preventDefault();
      var index = $(this).data("slide");
      if (index > 1) {
        showModal(index - 1);
      }
    });
    $(".lightbox-modal .next").click(function (e) {
      e.preventDefault();
      var index = $(this).data("slide");
      var max = $(this).data("total");
      if (index != max) {
        showModal(index + 1);
      }
    });
    $(".lightbox-modal .close").click(function (e) {
      e.preventDefault();
      closeModal();
      closeFullscreen();
    });
    $(".lightbox-modal .exit-fullscreen").click(function (e) {
      e.preventDefault();
      closeFullscreen();
    });
    $(".fullscreen").click(function (e) {
      e.preventDefault();
      openFullscreen();
      $(this).parent().addClass("fullscreen");
    });
    var elem = document.getElementById("lightbox-modal");
    function openFullscreen() {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    }
    function closeFullscreen() {
      $(this).parent().removeClass("fullscreen");
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  
    if (document.addEventListener) {
      document.addEventListener("fullscreenchange", exitHandler, false);
      document.addEventListener("mozfullscreenchange", exitHandler, false);
      document.addEventListener("MSFullscreenChange", exitHandler, false);
      document.addEventListener("webkitfullscreenchange", exitHandler, false);
    }
  
    function exitHandler() {
      if (
        !document.fullscreenElement &&
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement
      ) {
        $("#lightbox-modal").removeClass("fullscreen");
      }
    }
  
    document.addEventListener("swiped-right", function (e) {
      var index = $(e.target).parents(".lightbox-modal-slide").data("slide");
      if (index > 1) {
        showModal(index - 1);
      }
    });
    document.addEventListener("swiped-left", function (e) {
      var index = $(e.target).parents(".lightbox-modal-slide").data("slide");
      var max = $(e.target).parents(".lightbox-modal-slide").data("total");
      if (index != max) {
        showModal(index + 1);
      }
    });
  });

 // PDP thumbnails
  const previousThumbnail = document.querySelector('.thumbnails__previous');
  const nextThumbnail = document.querySelector('.thumbnails__next');
  const thumbnails = document.querySelector('.Product__SlideshowNav.Product__SlideshowNav--thumbnails');

  if (previousThumbnail) {
    previousThumbnail.addEventListener('click', function (e) {
      // thumbnails.scrollLeft = thumbnails.scrollLeft - 480;
      $("[js-slideshow-nav]").flickity('previous', true)
    });
  }

  if (nextThumbnail) {
    nextThumbnail.addEventListener('click', function (e) {
      // thumbnails.scrollLeft = thumbnails.scrollLeft + 480;
      $("[js-slideshow-nav]").flickity('next', true)

    });
  }


 